// eslint-disable-next-line import/no-cycle
import { HomeDetails, IDate, UUID } from '@avantstay/arriere-clients/dist/arriereBackoffice'
import { MaintenanceStatus, ToggleInputTypes } from '@avantstay/backoffice-core'

import { TapeChartRegion } from '@/_new/domains/bookingsTapeChart/BookingsTapeChart.types'

import { DateRange, SeasonType } from './seasonTypes'

export enum RateType {
  standard = 'STANDARD',
  yieldStandard = 'YIELD_STANDARD',
}

export type Property = {
  id: string
  name: string
  regionId?: string
  details?: HomeDetails
  region?: TapeChartRegion
  maintenanceStatus?: MaintenanceStatus
}

export enum PricingTapeChartEditType {
  rates,
  minNights,
  cico,
  reset,
}

export enum PricingTapeChartDataTypeViewMode {
  nightlyRates = 'nightlyRates',
  seasonsRates = 'seasonsRates',
}

export interface HomesMap {
  [key: string]: HomeObject
}

export interface HomeObject {
  id: string
  name: string
  regionName: string
  floorRate: number
  isOffboarded: boolean
  rateByMonth: number[]
  isIntegratedPricingEnabled?: boolean
}

export interface SeasonsDataObject {
  seasonPeriodId: string
  seasonName: string
  type: SeasonType
  period: DateRange
}

export interface SeasonPricingColumn {
  seasonPeriodId: UUID
  dayOfWeek: number
  numCols?: number
}

export interface SeasonDataMap {
  [key: string]: SeasonsDataObject
}

export interface TapeChartChangesMap {
  [key: string]: PricingTapeChartChange
}

export interface ConditionsSelection {
  minStay?: number
  maxStay?: number
  checkinAllowed?: boolean
  checkoutAllowed?: boolean
}

export interface PricingTapeChartChange {
  homeId: string
  date?: IDate
  rate?: number
  checkinAllowed?: boolean
  checkoutAllowed?: boolean
  minStay?: number
  seasonPeriodId?: string
  dayOfWeek?: number
  seasonPeriod?: { start: string; end: string }
}

export interface RateChangeHistoryItem {
  previousValue?: number
  newValue?: number
  date: IDate
  author: { kind: string; name: string }
  message?: string
  updatedAt: IDate
  previousConditions?: ConditionsSelection
  newConditions?: ConditionsSelection
}

export const rateTypesOptions = [
  {
    title: 'STD',
    value: RateType.standard,
    id: RateType.standard,
  },
  {
    title: 'Y-STD',
    value: RateType.yieldStandard,
    id: RateType.yieldStandard,
  },
]

export const dataViewModeOptions = [
  {
    title: 'Nightly Rates',
    value: PricingTapeChartDataTypeViewMode.nightlyRates,
    id: PricingTapeChartDataTypeViewMode.nightlyRates,
  },
  {
    title: 'Seasons Rates',
    value: PricingTapeChartDataTypeViewMode.seasonsRates,
    id: PricingTapeChartDataTypeViewMode.seasonsRates,
  },
]

export enum RateUpdateTypes {
  fixed = 'fixed',
  byValue = 'byValue',
  asFloorRate = 'asFloorRate',
}

export interface BulkUpdatePayload {
  rateToUpdate?: string
  kindOfRateUpdate?: ToggleInputTypes
  updateType?: RateUpdateTypes
  minStay?: number
  checkinAllowed?: boolean
  checkoutAllowed?: boolean
}
